module.exports = __webpack_public_path__ + "img/full-05.8f180fe6.png";